// extracted by mini-css-extract-plugin
export default {"container":"X6UVlvbMm5km9x3uv-liDw==","title":"slVleGJfkOtS-FXYXc+IGA==","blank-space":"QUxqVxYENnDbKladdQ+y1A=="};